import React from 'react';
import styled from 'styled-components';

import { ReactComponent as CircleTicked } from "../../static/images/circle-ticked.svg";

const Wrapper = styled.div`
    width: 28px;
    height: 28px;
`;

export default props => (
    <Wrapper {...props}>
        <CircleTicked />
    </Wrapper>
);